import { Component, output, ViewChild } from '@angular/core';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { EmrDialogComponent } from '../emr-dialog/emr-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'emr-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['../emr-dialog/emr-dialog.component.scss', './file-upload-dialog.component.scss'],
  standalone: true,
  imports: [
    DialogModule,
    FileUploadModule,
    ButtonDirective,
  ],
})
export class FileUploadDialogComponent extends EmrDialogComponent {
  file?: Blob;
  dialogClose = output<Blob>();
  @ViewChild('fileUploader') fileUploader?: FileUpload;

  closeDialog(): void {
    this.fileUploader?.clear();
    super.closeDialog();
  }

  /**
   * Get the file selected as a File object, and store the object.
   *
   * @param event Object passed from p-fileUpload containing file information.
   */
  onFileChange(event: any) {
    const files = event.currentFiles as File[];
    if (files && files.length > 0) {
      this.file = files[0];
    } else {
      this.file = undefined;
    }
  }

  onUpload() {
    if (this.fileUploader) {
      const files = this.fileUploader.files;
      if (files.length > 0) {
        this.file = files[0];
      }
    }
    this.dialogClose.emit(this.file!);
    this.display.set(false);
  }

  get didUploadFile(): boolean {
    return (
      this.fileUploader != undefined &&
      this.fileUploader.files &&
      this.fileUploader.files.length > 0
    );
  }
}
